<!-- BEGIN #header -->
<div id="header" class="app-header">
  <!-- BEGIN desktop-toggler -->
  <div class="desktop-toggler" *ngIf="showNavigation">
    <button type="button" (click)="app.sideBarCollapsed = !app.sideBarCollapsed" class="menu-toggler" data-bs-toggle="app-sidebar-collapsed" data-bs-target=".indicium-cloud">
      <i class="fa fa-bars"></i>
    </button>
  </div>
  <!-- BEGIN desktop-toggler -->
  
  <!-- BEGIN mobile-toggler -->
  <div class="mobile-toggler" *ngIf="showNavigation">
    <button type="button"  (click)="app.menuOpen = !app.menuOpen" class="menu-toggler" data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
      <i class="fa fa-bars"></i>
    </button>
  </div>
  <!-- END mobile-toggler -->
  
  <!-- BEGIN brand -->
  <div class="brand">
    <a href="#" class="brand-logo">
      <span class="brand-img" [style.background-image]="'url(' + app.logoUrl + ')'">
        <span class="brand-img-text text-theme"></span>
      </span>
      
      <span class="brand-text" *ngIf="app == null || app.applicationName == null || app.applicationName == ''">INDICIUM Cloud</span>
      <span class="brand-text" *ngIf="app && app.applicationName">{{app.applicationName}}</span>
    </a>
  </div>
  <!-- END brand -->
  
  <!-- BEGIN menu -->
  <div class="menu">

    <!-- GLOBAL SEARCH-->
    <!--<div class="menu-item dropdown">
      <a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app" class="menu-link">
        <div class="menu-icon"><i class="bi bi-search nav-icon"></i></div>
      </a>
    </div>-->
   
    <!-- Day/Night Toggle -->
    <div class="menu-item dropdown dropdown-mobile-full">
      <a class="menu-link" id="dropdown-customer" (click)="toggleTheme()">
        <div class="menu-icon">
            <i *ngIf="app.theme=='dark'" class="bi bi-sun nav-icon"></i>
            <i *ngIf="app.theme=='light'" class="bi bi-moon nav-icon"></i>
        </div>
      </a>
    </div>
    

    <!-- Who is watching? -->
    <div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated() && (authService.isAdmin() || authService.isOwner())">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-whoswatching" (click)="this.whoIsWatching()">
        <div class="menu-icon">
            <i class="bi bi-eye nav-icon"></i>
        </div>
      </a>
      <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" role="menu" aria-labelledby="dropdown-whoswatching">
        <h6 class="dropdown-header fs-10px mb-1">Whos Watching This Page</h6>
        <li role="menuitem" *ngFor="let who of whosWatching">
          <a class="dropdown-item">{{who}}</a>
        </li>
      </ul>
    </div>

    <!-- Customers -->
    <div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated() && app.customers">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-customer">
        <div class="menu-icon">
            <i class="bi bi-building nav-icon"></i>
        </div>
      </a>
      <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" role="menu" aria-labelledby="dropdown-customer">
        <h6 class="dropdown-header fs-10px mb-1">Customer : {{app.customer?.customerName}}</h6>
        <div class="dropdown-header"><input id="customerSearch" class="input-sm form-control form-control-sm" type="text" [(ngModel)]="customerFilter" (keydown.enter)="trySelectCustomer()" /></div>
        <hr class="bg-white-transparent-5 mb-0 mt-0" />
        <li role="menuitem" *ngFor="let customer of getCustomers()">
          <a class="dropdown-item" (click)="changeCustomer(customer)">{{customer.customerName}}</a>
        </li>
      </ul>
    </div>

    <!-- APPLICATIONS -->
    <!--<div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated()">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-applications">
        <div class="menu-icon">
            <i class="bi bi-grid-3x3-gap nav-icon"></i>
        </div>
      </a>
      <ul ngbDropdownMenu id="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" class="dropdown-menu" role="menu" aria-labelledby="dropdown-applications">
        <h6 class="dropdown-header fs-10px mb-1">APPLICATIONS</h6>
          <div class="row row-grid gx-0">
            <div class="col-12">
              <a *ngIf="app.applications == null || app.applications.length == 0" class="dropdown-item text-decoration-none p-3 bg-none">
                <div class="fw-500 fs-10px text">None Installed</div>
              </a>
            </div>
            <div *ngIf="app.applications">
                <div class="col-4" *ngFor="let app of app.applications" >
                  <a [routerLink]="app.link" class="dropdown-item text-decoration-none p-3 bg-none">
                    <div class="position-relative">
                      <i class="bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100"></i>
                      <i class="bi bi-envelope h2 opacity-5 d-block my-1"></i>
                    </div>
                    <div class="fw-500 fs-10px text">{{app.name}}</div>
                  </a>
                </div>
            </div>
          </div>
      </ul>
    </div>-->
    <div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated() && app.applicationAllowed('fire-foresight')">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-fireforesight">
        <div class="menu-icon">
            <i class="bi bi-fire nav-icon"></i>
        </div>
      </a>
      <ul ngbDropdownMenu id="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" class="dropdown-menu" role="menu" aria-labelledby="dropdown-fireforesight">
        <h6 class="dropdown-header fs-10px mb-1">FIRE FORESIGHT</h6>
        <div *ngIf="fire.unconfirmed == null || fire.unconfirmed.length == 0" class="d-flex align-items-center py-10px dropdown-item text-wrap fs-6 bg-white bg-opacity-15 text text-opacity-50 h-100px">
          No unconfirmed incidents
        </div>
        <div class="d-flex align-items-center py-10px dropdown-item text-wrap" *ngFor="let incident of fire.unconfirmed">
          <a class="d-flex align-items-center py-10px dropdown-item text-wrap" [routerLink]="['/fire-foresight/incident/' + incident.incidentId]">
            <div class="fs-20px">
              <i class="bi bi-fire text-theme"></i>
            </div>
            <div class="flex-1 flex-wrap ps-3">
              <div class="mb-1 text text-truncate fixed-menu-inner">{{incident.site?.name}}</div>
              <div class="small">{{incident.fireIncidentDate | relativeDate}}</div>
            </div>
            <div class="ps-2 fs-16px" *ngIf="incident.incidentId">
              <i class="bi bi-chevron-right"></i>
            </div>
          </a>
        </div>
      </ul>
    </div>

    <!-- Notifications -->
    <div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated()">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-notifications">
        <div class="menu-icon">
            <i class="bi bi-bell nav-icon"></i>
        </div>
        <div *ngIf="app.notifications && app.notifications.length > 0" class="menu-badge bg-theme"></div>
      </a>
      <ul ngbDropdownMenu id="dropdown-basic" class="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" role="menu" aria-labelledby="dropdown-notifications">
        <h6 class="dropdown-header fs-10px mb-1">NOTIFICATIONS</h6>
        <div *ngIf="app.notifications == null" class="d-flex align-items-center py-10px dropdown-item text-wrap fs-6 bg-white bg-opacity-15 text text-opacity-50 h-100px">
          No record found
        </div>
        <div class="d-flex align-items-center py-10px dropdown-item text-wrap" *ngFor="let notification of app.notifications">
          <a *ngIf="notification.notificationType == 'Data Download'" class="d-flex align-items-center py-10px dropdown-item text-wrap" [href]="notification.uri">
            <div class="fs-20px">
              <i *ngIf="notification.notificationType == 'Data Download'" class="bi bi-file-earmark-spreadsheet text-theme"></i>
            </div>
            <div class="flex-1 flex-wrap ps-3">
              <div class="mb-1 text text-truncate fixed-menu-inner">Data Download</div>
              <div class="small">{{notification.auditTime + 'Z' | relativeDate}}</div>
            </div>
            <div class="ps-2 fs-16px" *ngIf="notification.uri">
              <i class="bi bi-chevron-right"></i>
            </div>
          </a>

          <a *ngIf="notification.notificationType != 'Data Download'" class="d-flex align-items-center py-10px dropdown-item text-wrap" [routerLink]="['/data/analysis']" [queryParams]="{uri: notification.uri}">
            <div class="fs-20px">
              <i *ngIf="notification.notificationType == 'Email'" class="bi bi-envelope text-theme"></i>
              <i *ngIf="notification.notificationType == 'SMS'" class="bi bi-phone text-theme"></i>
            </div>
            <div class="flex-1 flex-wrap ps-3">
              <div class="mb-1 text text-truncate fixed-menu-inner">{{notification.data}}</div>
              <div class="small">{{notification.auditTime + 'Z' | relativeDate}}</div>
            </div>
            <div class="ps-2 fs-16px" *ngIf="notification.uri">
              <i class="bi bi-chevron-right"></i>
            </div>
          </a>
        </div>
        <hr class="bg-white-transparent-5 mb-0 mt-0" />
      </ul>
    </div>

     <!-- Time Zone -->
     <div ngbDropdown class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated()">
      <a ngbDropdownToggle type="" class="menu-link" id="dropdown-timezone">
        <div class="menu-icon">
            <i class="bi bi-clock nav-icon"></i>
        </div>
      </a>
      <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" role="menu" aria-labelledby="dropdown-timezone">
        <h6 class="dropdown-header fs-10px mb-1">Time Zones : {{app.tenantTimeZone}}</h6>
        <div class="dropdown-header"><input class="input-sm form-control form-control-sm" type="text" [(ngModel)]="timeZoneFilter"/></div>
        <hr class="bg-white-transparent-5 mb-0 mt-0" />
        <li role="menuitem" *ngFor="let tz of app.getTimeZones(timeZoneFilter, 10)">
          <a class="dropdown-item" (click)="app.setTenantTimeZone(tz)">{{tz}}</a>
        </li>
      </ul>
    </div>

    <!-- Account Details -->
    <div class="menu-item dropdown dropdown-mobile-full" *ngIf="authService.isAuthenticated()">  
      <div ngbDropdown class="btn-group">
        <a ngbDropdownToggle type="" class="menu-link" id="dropdown-account">
          <div class="menu-img online" title="authService.account.userName">
            <div class="d-flex align-items-center justify-content-center w-100 h-100 bg-white bg-opacity-25 text text-opacity-50 rounded-circle overflow-hidden">
              <i class="bi bi-person-fill fs-32px mb-n3"></i>
            </div>
          </div>
					<div class="menu-text d-sm-block d-none">{{authService.account.username}}</div>
        </a>
        <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1" role="menu" aria-labelledby="button-account">
           <li role="menuitem"><a class="dropdown-item" [routerLink]="'/user/api-keys'">API KEYS <i class="bi bi-user ms-auto text-theme fs-16px my-n1"></i></a></li>
           <li class="divider dropdown-divider"></li>
           <a *ngFor="let account of authService.accounts" class="dropdown-item d-flex align-items-center" (click)="changeAccount(account)">{{account.username}}
              <i *ngIf="account.username == authService.account.username; else accountoff" class="bi bi-toggle-on ms-auto text-theme fs-16px my-n1"></i>
              <ng-template #accountoff>
                <i class="bi bi-toggle-off ms-auto text-theme fs-16px my-n1"></i>
              </ng-template>              
            </a>
           <li class="divider dropdown-divider"></li>
           <a class="dropdown-item d-flex align-items-center" (click)="authService.loginNewAccount();">Sign in with different account</a>
           <a class="dropdown-item d-flex align-items-center"  [routerLink]="'/logout'">Sign out</a>
        </ul>
      </div>
    </div>  

     <!-- Account Name of Customer List-->
     <!--<div class="menu-item dropdown dropdown-mobile-full mr fixed-menu" *ngIf="authService.isAuthenticated()">
      <div class="menu-text d-sm-block d-none">Name {{authService.account?.userName}}</div>
      <div class="menu-text d-sm-block d-none" *ngIf="authService.isGlobalViewer()">
        <select *ngIf="app.customers && app.customers.length > 0" [(ngModel)]="app.customerId" class="form-select m-b" (change)="changeCustomer()">
            <option *ngFor="let c of app.customers" value="{{c.customerId}}">{{ c.customerName }}</option>
        </select>
      </div>
    </div>-->

  </div>
  <!-- END menu -->
  
  <!-- BEGIN menu-search -->
  <form class="menu-search" method="POST" name="header_search_form">
    <div class="menu-search-container">
      <div class="menu-search-icon"><i class="bi bi-search"></i></div>
      <div class="menu-search-input">
        <input type="text" class="form-control form-control-lg" placeholder="Search menu..." />
      </div>
      <div class="menu-search-icon">
        <a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app"><i class="bi bi-x-lg"></i></a>
      </div>
    </div>
  </form>
  <!-- END menu-search -->


</div>
<!-- END #header -->

<!-- Customer Message Modal -->
<div class="modal fade" bsModal #customerMessageModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="customerMessageModalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-warning text-white">
      <div class="modal-header bg-warning border-warning">

        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" (click)="customerMessageModal.hide()"></button>
      </div>
      <div class="modal-body bg-warning  border-warning">
        <div class="d-flex align-items-start">
          <div class="flex-shrink-0">
            <i class="bi bi-exclamation-triangle-fill fs-1 text-white"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <p class="fs-5 mb-0 text-white">{{authService.userProfile?.customerMessage}}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-warning border-warning">
        <button type="button" class="btn btn-light" (click)="customerMessageModal.hide()">
          <i class="bi bi-check-circle me-1"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>